import { useParams } from 'react-router-dom';
import { useModal } from 'src/hooks/modalHooks';
import { useStoreUnitActions } from 'src/redux/helpers';
import { isModalComplete } from 'src/components/ModalDialog';
import { DataTableActions } from 'src/components/DataTable';
import solutionsStore from '../../redux';
import { useSolutionUserRoles } from '../../hooks';
import { SolutionMappingConfigItem } from '../../types';
import SolutionMappingEditContainer from './SolutionMappingEditContainer';
import SolutionMappingDeleteModal from './SolutionMappingDeleteModal';

type Props = {
  item?: SolutionMappingConfigItem;
};

function SolutionMappingConfigAction({ item }: Props) {
  const { solutionId } = useParams();
  const actions = useStoreUnitActions(solutionsStore);
  const { isValidSolutionOwner } = useSolutionUserRoles(solutionId);
  const onClose = (reason) => isModalComplete(reason);

  const [deleteDialog, showDeleteDialog] = useModal(
    SolutionMappingDeleteModal,
    {
      item,
      onClose,
    }
  );

  const [editDialog, showEditDialog] = useModal(SolutionMappingEditContainer, {
    item,
    onClose,
  });

  return (
    <DataTableActions
      canEdit={isValidSolutionOwner}
      canDelete={isValidSolutionOwner}
      onEdit={showEditDialog}
      onDelete={showDeleteDialog}
      showDelete={true}
    >
      {editDialog}
      {deleteDialog}
    </DataTableActions>
  );
}

export default SolutionMappingConfigAction;
